import { RichText } from 'live/components/forms/ui/RichText'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'

export const ButtonStatusCard = styled.button`
    display: inline-block;
    border: none;
    font-style: normal;
    ${({ bold = false }): string => (bold ? 'font-weight: 600;' : 'font-weight: normal;')}
    font-size: 12px;
    ${({ width = null }: { width?: number | string | null }): string | null =>
        width ? `min-width: ${width}px;` : null}
    ${({ width = null }: { width?: number | string | null }): string | null =>
        width ? `max-width: ${width}px;` : null}
    text-align: center;
    margin-right: 5px;
    ${({ color }: { color?: string }): string | null => (color ? `background-color: ${color};` : null)}
    color: #ffffff;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    height: 20px;
    margin: auto 5px auto 0px;
`

export const DivMainCard = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    min-height: 60px;
    align-items: left;
    margin: 0px 5px;

    ${({ margin }: { margin?: string }) => (margin ? `margin: ${margin};` : null)}
    ${({ backgroundColor }: { backgroundColor?: string }) =>
        backgroundColor ? `background-color: ${backgroundColor};` : null}
 
    border-top: 1px solid #DDDEE1;
    box-sizing: border-box;

    align-items: center;
    align-content: left;

    text-align: justify;
    > i {
        width: 10px;
        height: 10px;
        margin-right: 12px;
        margin-left: 8px;
        visibility: hidden;
    }
    .fa-trash-alt {
        color: #d9534f;
    }
    .fa-download {
        color: #37a3ef;
    }

    :hover {
        border: 1px solid #dddee1;
        box-shadow: 0px 1px 4px rgba(23, 32, 51, 0.25);
        ${({ cursor = 'pointer' }: { cursor?: string }): string => `cursor: ${cursor};`}
        background-color:  #E1F0FF;

        > i {
            visibility: visible;
            cursor: pointer;
        }
    }
`

export const DivValueBarCard = styled.div`
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    height: 100%;
    flex-direction: row;
    align-items: left;
    justify-content: space-around;

    ${({ padding }: { padding?: string }) => (padding ? `padding: ${padding};` : null)}
`

export const DivFieldSetDateWithClear = styled.i`
    display: flex;
    flex-direction: row;
    font-weight: normal;
    > i {
        font-size: 16px;
        color: #37a3ef;
        cursor: pointer;
    }
`

export const IconStatusCard = styled.i`
    display: inline-block;
    font-style: normal;
    ${({ bold = false }): string => (bold ? 'font-weight: 600;' : 'font-weight: normal;')}
    font-size: 12px;
    line-height: 12px;
    ${({ width = null }: { width?: number | string | null }): string | null =>
        width ? `min-width: ${width}px;` : null}
    ${({ width = null }: { width?: number | string | null }): string | null =>
        width ? `max-width: ${width}px;` : null}
    text-align: left;

    margin: auto 5px auto 0px;
    ${({ color }: { color?: string }): string | null => (color ? `color: ${color};` : null)}
    align-items: center;
`

export const SpanStatusCard = styled.div`
    display: inline-block;
    font-style: normal;
    font-size: 12px;
    line-height: 16px;

    ${({ bold = false }): string => (bold ? 'font-weight: 600;' : 'font-weight: normal;')}

    ${({ width = null }: { width?: number | string | null }): string | null =>
        width ? `min-width: ${width}px;` : null}
    ${({ width = null }: { width?: number | string | null }): string | null =>
        width ? `max-width: ${width}px;` : null}
    text-align: left;
    margin: auto 5px auto 0px;
    ${({ color }: { color?: string }): string | null => (color ? `color: ${color};` : null)}
    align-items: center;

    text-align: justify;

    overflow: visible;

    text-overflow: ellipsis;
`

export const SpanDoubleTopStatusCard = styled.div`
    display: flex;
    font-style: normal;
    font-size: 12px;
    line-height: 12px;

    ${({ bold = false }): string => (bold ? 'font-weight: 600;' : 'font-weight: normal;')}
    width: auto;
    text-align: left;
    margin: auto 2px auto 0px;
    ${({ color }: { color?: string }): string | null => (color ? `color: ${color};` : null)}
    align-items: center;

    text-align: justify;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`

export const SpanDoubleBottomStatusCard = styled.div`
    display: flex;
    font-style: normal;
    font-size: 11px;
    line-height: 10px;
    color: #868695;

    ${({ bold = false }): string => (bold ? 'font-weight: 600;' : 'font-weight: normal;')}
    width: 40%;
    text-align: left;
    margin: auto auto auto 2px;
    ${({ color }: { color?: string }): string | null => (color ? `color: ${color};` : null)}
    align-items: center;

    text-align: justify;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`

export const DivDoubleStatusCard = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    ${({ width = null }: { width?: number | string | null }): string | null =>
        width ? `min-width: ${width}px;` : '100%'}
    ${({ width = null }: { width?: number | string | null }): string | null =>
        width ? `max-width: ${width}px;` : '100%'}

    > * {
        flex: 1;
    }
`

export const DivCardNotFound = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    ${({ height = '130px' }: { height?: string }): string => `height: ${height};`}
    text-align: center;
    background-color: #f8f8f8;
    border: 1px solid #dddee1;
    margin-bottom: 13px;
    ${({ margin = '20px 0' }: { margin?: string }): string => `margin: ${margin};`}
    ${({ padding = '42px 24px' }: { padding?: string }): string => `padding: ${padding};`}
    justify-content: center;
    align-items: center;

    > span {
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 14px;
        align-items: center;
        color: #364159;
    }
`

export const DivContainerDropdown = styled.div`
    display: block;
    position: relative;
    background-color: #ffffff;
    margin-left: 15px;
    justify-content: center;
    align-items: center;
    height: 35px;
    min-width: 180px;
    max-width: 180px;

    &.disabled {
        background: rgba(204, 204, 204, 0.6);
        opacity: 0.4;
        cursor: not-allowed;
    }
    border: 1px solid #ccc;
    border-radius: 3px;
    &.open {
        z-index: 2;
    }
    padding-left: 16px;
    min-width: ${({ width = 180 }: { width: number }): string => `${width}%`};
    max-width: ${({ width = 180 }: { width: number }): string => `${width}%`};
`

export const DivSelectDropdown = styled.div`
    height: 100%;
    user-select: none;
`

export const DivVisibleDropdown = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
`

export const DivCaretDropdown = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 16px;
    opacity: 0.7;
    :hover {
        opacity: 1;
    }
    cursor: pointer;
    > i {
        color: #37a3ef;
    }
`

export const DivLabelDropdown = styled.div`
    > i {
        color: #37a3ef;
    }
    > span {
        padding-left: 12px;
        font-weight: bold;
        font-size: 14px;
    }
`

export const DivContentDropdown = styled.div`
    /* position: absolute;
    width: 300px;
    ${({ height = '160px' }) => `height: ${height}`};
    border: 1px solid #ccc;
    border-radius: 3px;
    overflow-x: none;
    overflow-y: auto;
    right: -1px;
    background-color: #ffffff;
    margin-top: 5px;
    padding: 16px 16px; */

    padding: 16px 16px;
    left: auto;
    /* right: 0; */
    width: 240px;
    right: -1px;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    float: left;
    min-width: 160px;
    margin: 2px 0 0;
    list-style: none;
    font-size: 14px;
    text-align: left;
    background-color: #fff;
    border: 1px solid #ccc;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 2px;
    -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    -moz-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    background-clip: padding-box;
    
`

export const DivMainFilters = styled.div`
    display: flex;
    width: 100%;
    height: 48px;
    background-color: #eeeeee;
    justify-content: center;

    > div {
        display: flex;
        flex-direction: row;
        width: 940px;
        max-width: 940px;
        height: 100%;
        align-items: center;

        > span {
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 16px;
            align-items: center;
            color: #364159;
        }
    }
`

export const DivFormBoxEdit = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: #ffffff;
    border: 1px solid #dddee1;
    box-sizing: border-box;
    border-radius: 3px;
    box-shadow: 0 0 5px 0 rgba(54, 65, 89, 0.2);
    font-family: 'SourceSansPro-Semibold';

    margin-bottom: 20px;

    @media print {
        display: inline-flex;
        float: none !important;
        position: static !important;
        box-sizing: content-box !important;

        page-break-after: avoid;
        page-break-before: auto;
        page-break-inside: avoid;
        break-after: avoid;
        break-before: auto;
        break-inside: avoid;
    }
`

export const DivFormTitle = styled.div`
    display: flex;
    flex-direction: row;

    width: 100%;
    height: 46px;

    justify-content: space-between;

    padding: 13px 20px 14px;
    > span {
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 16px;

        text-transform: uppercase;

        color: #364159;
    }

    > div {
        display: flex;
        flex-direction: row;

        ${({ disabled }: { disabled: boolean }) => (disabled ? 'color: #AAAAAA;' : 'color: #37A3EF;')}
        ${({ disabled }: { disabled: boolean }) => (disabled ? 'cursor: not-allowed;' : 'cursor: pointer;')}

        >i {
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;

            display: flex;
            align-items: center;
            text-align: center;

            margin: auto 8px;
        }

        > span {
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 16px;

            display: flex;
            align-items: center;
        }
    }
`

export const DivContainerInput = styled.div`
    display: flex;
    align-items: center;
    border: 1px solid #ccc;
    border-radius: 3px;
    background-color: #ffffff;
    height: 35px;
    width: 100%;

    > i {
        display: flex;
        width: 15px;
        height: 15px;
        font-size: 15px;
        margin: 8px;
        color: #868695;
        align-items: center;
        justify-content: center;
    }

    > input {
        width: calc(100% - 46px);
        border: none;
        outline: none;
        font-size: 16px;
        margin: 0 10px 0px 0px;
        display: flex;
        flex-grow: 1;
        font-size: 15px;
    }
`

export const DivLoading = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    > label {
        margin-top: 24px;
        font-size: 16px;
    }
`

export const ButtonLoadMore = styled.button`
    display: flex;
    flex-direction: row;

    min-width: 160px;
    max-width: 160px;
    height: 35px;

    background-color: #37a3ef;
    color: #ffffff;

    justify-content: center;
    align-items: center;

    margin-right: 15px;
    padding: 8px 16px;

    border: 1px solid #008ac7;
    box-sizing: border-box;
    border-radius: 3px;
    cursor: pointer;

    :focus {
        outline: #008ac7 5px auto;
    }

    > i {
        display: flex;
        width: 15px;
        height: 15px;
        font-size: 15px;
        margin-right: 5px;
        color: #ffffff;
        align-items: center;
        justify-content: center;
    }

    > span {
        display: flex;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 16px;
        align-items: center;
    }
`

export const DivMainCadsTitle = styled.div`
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    flex-direction: row;
    align-items: left;
    justify-content: space-around;

    ${({ background = null }: { background?: string | null }): string | null =>
        background ? `background-color: ${background};` : null}

    min-height: 25px;
    align-items: left;

    ${({ margin = '30px 5px 10px' }: { margin?: string }): string => `margin: ${margin};`}

    ${({ padding = '0px 30px 0px 0px' }: { padding?: string }): string =>
        `padding: ${padding};`}

    align-content: left;
`

export const SpanStatusTitle = styled.div`
    display: flex;
    font-style: normal;
    font-size: 11px;
    line-height: 12px;
    ${({ width = null }: { width?: number | string | null }): string | null =>
        width ? `min-width: ${width}px;` : null}
    ${({ width = null }: { width?: number | string | null }): string | null =>
        width ? `max-width: ${width}px;` : null}
    text-align: left;
    margin-right: 5px;
    color: #606a80;
    align-items: center;
    cursor: pointer;
    font-weight: 600;

    > i {
        margin-left: 5px;
    }
`

export const DivFieldSetContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;

    @media print {
        display: block;
    }
`

export const DivActiveFiltersContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-self: center;
    width: 940px;

    background: #f5f5f5;

    border: 1px solid #eeeeee;
    box-sizing: border-box;
    border-radius: 4px;

    margin: 12px 10%;

    ${({ marginBottom = '0px' }) => `margin-bottom: ${marginBottom}`}

    padding: 10px 0px;

    > i {
        margin: auto 15px auto 15px;

        color: #868695;
    }
`

export const DivActiveFiltersMainLabels = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    width: 100%;

    margin: auto 0px auto 0px;

    > div {
        display: flex;
        flex-direction: row;

        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 12px;

        color: #868695;

        margin: 8px 16px 8px 0px;

        > span {
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            line-height: 12px;

            color: #606a80;

            margin-left: 6px;
        }
    }
`

export const DivActiveFiltersControl = styled.div`
    display: flex;
    flex-direction: row;

    width: 84px;

    margin: auto 0px auto 15px;

    cursor: pointer;

    > i {
        margin: auto 8px auto 8px;
        color: #37a3ef;

        font-style: normal;
        font-weight: normal;
        font-size: 11px;
        line-height: 16px;

        cursor: pointer;
    }
    > span {
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 16px;

        display: flex;
        align-items: center;

        color: #37a3ef;

        cursor: pointer;
    }
`

export const DivCommentCard = styled.div`
    display: flex;
    flex-direction: column;

    width: 100%;

    padding: 5px 10px;
`

export const DivCommentHeader = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;

    > i {
        margin: 5px;
    }

    > span {
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;
        text-align: left;

        margin: auto 5px;
        min-width: 10px;
        color: #364159;
    }

    > div {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        text-align: left;

        margin: auto 5px;
        min-width: 100px;
        color: #364159;
    }
`

export const DivCommentBody = styled.div`
    display: flex;
    width: 100%;
    min-height: 50px;
    padding-left: 30px;

    > span {
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 16px;
        text-align: justify;

        color: #606a80;
        margin-top: 12px;
        width: 100%;
        height: 100%;
        color: #364159;
    }
`

export const DivHorizontalSeparator = styled.div`
    ${({ color = '#364159' }: { color: string }) => `border-top: solid 1px ${color};`};
    margin: 10px 0px;

    ${({ height = 80 }) => `height: ${height}%;`}
`

export const SpanNewComment = styled.span`
    margin: 10px 0px;

    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    text-align: left;

    color: #364159 !important;
`

export const DivRichText = styled(RichText)`
    ${({ disabled }) =>
        disabled
            ? `
        caret-color: transparent;
        cursor: default;
    `
            : null};

    line-height: 20px;
    margin: 6px 0px;

    .rdw-editor-toolbar {
        position: absolute;
        top: -45px;
        right: 0px;
        width: 205px;
        padding: 0px;
        height: 20px;
        border: 0px;
        margin: 0px;
        display: flex;
    }
    .DraftEditor-editorContainer {
        max-width: 900px;
    }
`

export const DivFieldRichText = styled(RichText)`
    line-height: 20px;
    margin: 6px 0px;
    .rdw-editor-toolbar {
        position: absolute;
        top: -25px;
        right: 0px;
        width: 205px;
        padding: 0px;
        height: 20px;
        border: 0px;
        margin: 0px;
        display: flex;
    }
    .DraftEditor-editorContainer {
        max-width: 900px;
    }
    ${({ disabled }) =>
        disabled
            ? `
        caret-color: transparent;
        cursor: default;

        .rdw-editor-toolbar {
            display: none;
        }
    `
            : ` .rdw-editor-toolbar {
        display: flex !important;
    }`};
`

export const DivMain = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    ${({ height = 'calc(100vh - 35px)' }: { height?: string }) => `height: ${height};`}
    font-family: SourceSansPro-Regular,Arial,Helvetica Neue,Helvetica,sans-serif;
`

export const DivMainTitle = styled.div`
    display: flex;
    width: 100%;
    height: 36px;
    top: 36px;
    background: #eeeeee;
    justify-content: center;
    border-bottom: 1px solid #dddee1;

    > div {
        display: flex;
        flex-direction: row;
        width: 80%;
        min-width: 940px;
        max-width: 940px;
        height: 100%;
        align-items: center;

        > span {
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 16px;
            align-items: center;
            ${({ color }: { color?: string }): string => (color ? `color: ${color};` : `color: #364159;`)}
        }
    }
`

export const ButtonAddItem = styled.button`
    ${({ readOnly }: { readOnly?: boolean }): string =>
        readOnly
            ? `
      background-color: #868695;
      border: 1px solid #868695;
      cursor: not-allowed;
    `
            : `
      background-color: #37A3EF;
      border: 1px solid #008AC7;
      cursor: pointer; 
      :focus {
        outline: #008AC7 5px auto;
      }
    `}

    display: flex;
    flex-direction: row;

    min-width: 160px;
    max-width: 160px;
    height: 35px;

    color: #ffffff;

    justify-content: center;
    align-items: center;

    margin-right: 15px;
    padding: 8px 16px;

    box-sizing: border-box;
    border-radius: 3px;

    > i {
        display: flex;
        width: 15px;
        height: 15px;
        font-size: 15px;
        margin-right: 8px;
        color: #ffffff;
        align-items: center;
        justify-content: center;
    }

    > span {
        display: flex;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 16px;
        align-items: center;
    }
`

export const DivMainBody = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;

    overflow-y: hidden;
    overflow-x: hidden;
`

export const DivMainCards = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    align-items: center;
`
export const DivOverflowCards = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;

    overflow-y: auto;
    scrollbar-width: none; /* For Firefox */
    -ms-overflow-style: none; /* For Internet Explorer and Edge */
    ::-webkit-scrollbar {
        /* For Chrome Opera and Safari */
        width: 0px;
    }
`

export const DivContainerCards = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 940px;
    max-width: 940px;
    height: 100%;
    align-items: center;
`

export const DivFixedHeader = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 940px;
    max-width: 940px;
    align-items: center;
`

export const DivStatusBarCard = styled.div`
    background-color: ${({ color = 'blue' }: { color: string }): string => color};
    border-radius: 3px 0px 0px 3px;
    width: 6px;
    height: 100%;
`
export const MainModal = styled(Modal)`
    > .modal-dialog {
        ${({ width = '630px' }: { width: string }) => `width: ${width};`}
        margin: 30px auto;
        height: 500px;
        > .modal-content {
            ${({ width = '630px' }: { width: string }) => `width: ${width};`}
            height: 500px;
            > .modal-body {
                display: flex;
                padding-top: 0px;
                padding-bottom: 0px;
                > div {
                    padding-top: 16px;
                    padding-bottom: 16px;
                }
            }
        }
    }
`

export const DivFormSingleValue = styled.div`
    display: flex;
    align-items: center;
    min-height: 52px;
    max-height: 52px;
    height: 52px;
    width: 100%;
    background-color: #eeeeee;
    margin-bottom: 22px;

    border: 1px solid #c8ccd4;
    box-sizing: border-box;
    border-radius: 4px;
    box-shadow: 0 0 5px 0 rgba(54, 65, 89, 0.1);

    > span {
        padding: 13px 0px 14px 20px;
        justify-content: flex-start;
        font-size: 1.1rem;
        flex: 5;
        color: #606a80;
        font-family: SourceSansPro-Semibold;
        text-transform: uppercase;
    }

    > div {
        display: flex;
        flex: 1;
        align-items: center;
        font-family: SourceSansPro-Regular;
        background-color: #ffffff;
        padding: 13px 11px 14px 20px;
        height: 100%;
        border-radius: 0 4px 4px 0;
        border-left: solid 1px #c8ccd4;
        color: #364159;
        font-size: 1.3rem;
    }

    @media print {
        display: inline-flex;
        float: none !important;
        position: static !important;
        box-sizing: content-box !important;

        page-break-after: avoid;
        page-break-before: auto;
        page-break-inside: avoid;
        break-after: avoid;
        break-before: auto;
        break-inside: avoid;
    }
`

export const DivFormImportantValue = styled.div`
    display: flex;
    align-items: center;
    min-height: 68px;
    max-height: 68px;
    width: 100%;
    background-color: #ffffff;
    margin-bottom: 22px;

    border: 1px solid #c8ccd4;
    box-sizing: border-box;
    border-radius: 4px;
    box-shadow: 0 0 5px 0 rgba(54, 65, 89, 0.2);

    > span {
        padding: 13px 0px 14px 20px;
        justify-content: flex-start;
        font-size: 1.4rem;
        flex: 5;
        color: #606a80;
        text-transform: uppercase;

        b {
            font-family: SourceSansPro-Semibold;
            color: #172033;
        }
        i {
            font-family: SourceSansPro-Regular;
        }
    }

    > div {
        display: flex;
        flex: 1;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        padding: 13px 11px 14px 20px;
        height: 100%;
        border-radius: 0 4px 4px 0;
        border-left: solid 1px #c8ccd4;
        color: #364159;

        > span:last-of-type {
            font-size: 1.1rem;
            font-family: SourceSansPro-Regular;
        }

        > span:first-of-type {
            font-size: 1.4rem;
            font-family: SourceSansPro-Semibold;
        }
    }

    @media print {
        display: inline-flex;
        float: none !important;
        position: static !important;
        box-sizing: content-box !important;

        page-break-after: avoid;
        page-break-before: auto;
        page-break-inside: avoid;
        break-after: avoid;
        break-before: auto;
        break-inside: avoid;
    }
`

export const LabelHeaderSheet = styled.span`
    font-size: 1.1rem;
    font-family: 'SourceSansPro-Semibold';
    color: #606a80;
`

export const ButtonDeleteRow = styled.i`
    color: #d9534f;
    position: absolute;
    right: -20px;
    margin: 15px 0 0 0;
    cursor: pointer;
`

export const DivBreaker = styled.div`
    /* display: none; */

    @media print {
        display: block;

        /* page-break-after: always;
        page-break-before: always;
        page-break-inside: avoid;
        break-after: always;
        break-before: always;
        break-inside: avoid; */
    }
`
